/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import "./Notfound.css";
import React from "react";
import { ERROR_PAGE_LOGO, ERROR_LOGO } from "../../../constants/Constants";
export default class Notfound extends React.Component {
  render() {
    return (
      <div className="error-wrapper">
        <div className="error_logo">
          <div className="error-img">
            <img alt="" src={ERROR_PAGE_LOGO} />
          </div>
        </div>
        <div className="error_message">
          <div className="container">
            <div className="error_inner">
              <div className="wizard-sad-logo">
                <img alt="" src={ERROR_LOGO} />
              </div>
              <div className="error_content">
                <h3>Spell 404</h3>
                <p className="e-con">Poof! This page has vanished.</p>
                <p className="e-warning">
                  Sorry if you hit this page in error. Please try again to find
                  what <br /> you need.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
